import {
  IQuickVideo,
  IQuickVideoForm,
  IQuickVideoPartForm,
  IQuickVideoPartPositionOption,
  QuickVideoCategory,
} from 'lib/api/quickVideo/types';

export const getQuickVideoInitialValues = ({
  defaultCategory,
  videoPositionDropdowns,
  quickVideo,
}: {
  defaultCategory: QuickVideoCategory;
  videoPositionDropdowns: IQuickVideoPartPositionOption[];
  quickVideo?: IQuickVideo | null;
}) => {
  let quickVideoParts: IQuickVideoPartForm[] = videoPositionDropdowns.map(
    vpd => ({
      partPosition: vpd.value,
      partType: '',
      video: undefined,
      description: '',
      quickVideoPartId: 0,
    })
  );

  if (!!quickVideo) {
    // replace existing parts
    quickVideoParts.forEach((part, index) => {
      const matchingProvidedPart = (quickVideo.quickVideoParts || []).find(
        p => p.partPosition === part.partPosition
      );

      if (!!matchingProvidedPart) {
        const userConfigs =
          matchingProvidedPart?.quickVideoPartUserConfigurations;
        const customerConfig =
          matchingProvidedPart?.quickVideoPartCustomerConfiguration;

        const hasUserConfigurations = !!userConfigs && userConfigs.length > 0;

        // replace and populate video if exists
        quickVideoParts[index] = {
          partPosition: matchingProvidedPart.partPosition,
          partType: matchingProvidedPart.partType,
          description: matchingProvidedPart.description || '',
          video:
            customerConfig?.video ||
            (hasUserConfigurations && userConfigs[0]?.video) ||
            null,
          quickVideoPartId: matchingProvidedPart.quickVideoPartId,
        };
      }
    });
  }
  return {
    name: quickVideo?.name || '',
    description: quickVideo?.description || '',
    category: quickVideo?.category || defaultCategory,
    sendEmail: quickVideo?.sendEmail || 1,
    sendSms: quickVideo?.sendSms || 1,
    smsText: quickVideo?.smsText || '',
    quickVideoParts,
    generateEmailSmsContent: quickVideo
      ? quickVideo?.generateEmailSmsContent
      : 1,
    emailContent: {
      subject: quickVideo?.emailContent?.subject || '',
      body: quickVideo?.emailContent?.body || '',
      elements: quickVideo?.emailContent?.elements || [],
      signature: quickVideo?.emailContent?.signature || {},
    },
  } satisfies IQuickVideoForm;
};
